import React, { useState } from "react";
import {  Row, Col, Modal, Card } from "react-bootstrap";
import ContactUsSection from "./ContactUsSection";
import { CiFacebook } from "react-icons/ci";
import { IoLogoInstagram } from "react-icons/io";
import { CiLinkedin } from "react-icons/ci";
import { CiTwitter } from "react-icons/ci";

import '../styles/Footer.css'
import { Link } from "react-router-dom";

const Footer = () => {
  const [showContactModal, setShowContactModal]=useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleShowContactModal = () => setShowContactModal(true);
  const handleCloseContactModal = () => setShowContactModal(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const cardsData = [
    { id: 1, title: "Malibu", image: "/assets/images/search1.jpg" },
    { id: 2, title: "Bel Air", image: "/assets/images/search2.jpg" },
    { id: 3, title: "Pacific Palisades", image: "/assets/images/search3.jpg" },
    { id: 4, title: "Brentwood", image: "/assets/images/search4.jpg" },
    { id: 5, title: "Beverly Glen", image: "/assets/images/search5.jpg" },
    { id: 6, title: "Hollywood", image: "/assets/images/search6.jpg" },
    { id: 7, title: "Santa Monica", image: "/assets/images/search7.jpg" },
    { id: 8, title: "Venice", image: "/assets/images/search8.jpg" },
    { id: 9, title: "Westwood", image: "/assets/images/search9.jpg" },
    { id: 10, title: "Hollywood Hills", image: "/assets/images/search10.jpg" },
  ];

  return (
    <div>
    <footer className="footer bg-base-200 text-base-content p-10">
  <aside>
    <h1>Newsletter</h1>
    <p>
      For exclusive news and market updates sign up for our newsletter.
    </p>
    <form className='w-85'>
    <fieldset className="form-control ">
      <div className="join">
        <input
          type="text"
          placeholder="Enter Email"
          className="input input-bordered join-item w-80" />
        <button className="btn btn-dark join-item">Subscribe</button>
        
      </div>
      <div className="flex items-start ms-3 mt-2 mb-10 w-80">
              <input
                type="checkbox"
                id="privacyPolicy"
                className="w-5 h-5 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
              />
              <label
                htmlFor="privacyPolicy"
                className="ml-3 text-gray-600 text-xs text-justify font-normal leading-6"
              >
                By providing Alex Turner Estates your contact information, you acknowledge 
                and agree to our <a href="#home" className="text-dark underline ">Privacy Policy</a> and consent to receiving marketing communications, 
                including through automated calls, texts, and emails, some of which may 
                use artificial or prerecorded voices. This consent isn't necessary for purchasing 
                any products or services and you may opt out at any time. To opt out from texts, 
                you can reply, 'stop' at any time. To opt out from emails, you can click on the 
                unsubscribe link in the emails. Message and data rates may apply.
              </label>
            </div>
    </fieldset>
    
  </form>
  <div className="FTSOCiAL mt-5">
                  <ul>
                    <li>
                      <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                      <CiFacebook />
                      </a>
                    </li>
                    <li>
                      <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                      <CiTwitter />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
                        <CiLinkedin />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
                        <IoLogoInstagram/>
                      </a>
                    </li>
                  </ul>
                </div>
  </aside>
  <nav className='mt-5 p-5'>
    <h6 className="footer-title">Contact Us</h6>
    <p>Alex Turner</p>
    <p>CA DRE #00526877</p>
    <a href='#email' className="link link-hover">alexturner@abc.com</a>
    <a href='#phone' className="link link-hover">123-456-7890</a>
  </nav>
  <nav className='mt-5 p-5'>
    <h6 className="footer-title">Address</h6>
    <p> 301 N Canon Dr. Suite R-05
    <br />Beverly Hills, CA 90210</p>
    
  </nav>
  <nav className='mt-5 p-5'>
    <h1 className="fontfamily">Alex Turner</h1>
    <button  className="link link-hover" onClick={handleShowModal}>Search</button>
    <Link to='/aboutInfo' className="link link-hover">About Alex</Link>
    <a href='#communities' className="link link-hover">Communities</a>
    <button className="link link-hover" onClick={handleShowContactModal}>Contact</button>
  </nav>

  
</footer>

<footer className="footer bg-base-200 text-base-content border-base-300 border-t px-10 py-4">
  <aside className="grid-flow-col items-center">
    <img src='/assets/images/hallmark.jpg' style={{height:'120px', width:'120px', borderRadius:'50%'}} alt='hallmark'/>
    <h4 style={{fontFamily:'Cantata One, serif'}}>Global Realty Partners</h4>
  </aside>
  
</footer>
<footer  className="footer bg-base-200 text-base-content border-base-300 px-10 py-4">
<p>
    The property details provided are sourced from multiple platforms, including public records and third-party databases. While efforts are made to ensure the accuracy of the information, it is presented as-is without any guarantees or warranties, and personal verification is recommended. This is not a solicitation if your property is already listed with another real estate professional. Partnered agents operate as independent contractors, not employees. ©2024 Real Estate Network. All Rights Reserved. Real Estate Network and associated logos are registered trademarks of Real Estate Network LLC. Franchise offices are independently owned and operated, while company-owned offices are subsidiaries of Global Realty Partners LLC. The Real Estate Network fully upholds the principles of the Fair Housing Act and Equal Opportunity Act.
    </p>
</footer>
<div className='footer bg-base-200 text-base-content border-base-300 px-8 py-4'>
                <p className='flex text-sm font-medium'>Copyright © 2024 | All the images in the site are designed by: <a href="https://www.freepik.com/" className="text-dark underline ">Freepik</a>, Video: <a href="https://www.pexels.com/" className="text-dark underline ">Pexels</a></p>
                <p className='flex ml-auto text-sm font-medium'>Powered by <span className='text-primary'>Leapot Technologies</span></p>
                
</div>


<Modal show={showContactModal} onHide={handleCloseContactModal} fullscreen>
        <Modal.Header closeButton>
        <h1 className="ms-5">Contact Us</h1>
        </Modal.Header>
        <Modal.Body>
          <ContactUsSection />
        </Modal.Body>
        
      </Modal>


      <Modal show={showModal} onHide={handleCloseModal} fullscreen variant='dark'>
        <Modal.Header closeButton  className="d-flex justify-content-center align-items-center">
          <h1 className=" display-4 text-center w-100">Click an Area to Start Your Search</h1>
        </Modal.Header>
        <Modal.Body>
        <Row className="g-4 ">
            {cardsData.map((card) => (
              <Col key={card.id} xs={12} sm={6} md={4}>
                <Card className="h-100 w-100 text-center custom-card border-0">
                  <div
                    className="card-background"
                    style={{ backgroundImage: `url(${card.image})`, width:'100%', height:'300px',borderRadius:'10px' }}
                  >
                    <div className="card-overlay">
                      <Card.Title className="text-white " style={{fontFamily:'Cantata One, serif', fontSize:'25px'}}>{card.title}</Card.Title>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Modal.Body>
      </Modal>

</div>
  )
}

export default Footer;
